var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.6,
    height: 14.14,
    viewBox: "0 0 14.6 14.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6,7.07a.86.86,0,0,1-.86.85H2.9l4.77,4.76a.86.86,0,0,1,0,1.21.89.89,0,0,1-.6.25.86.86,0,0,1-.6-.25L.25,7.67h0a1.27,1.27,0,0,1-.18-.27.91.91,0,0,1,0-.65,1,1,0,0,1,.18-.26h0L6.47.25a.85.85,0,1,1,1.2,1.2L2.9,6.22H13.74A.86.86,0,0,1,14.6,7.07Z",
    fill: "#624de3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack2);
export default __webpack_public_path__ + "static/media/back-2.7f989e80dffc12b2c908de9e63abafa1.svg";
export { ForwardRef as ReactComponent };